// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"ErrorPage_errorContainer__24hta","errorInfo":"ErrorPage_errorInfo__3ku5b","errorImage":"ErrorPage_errorImage__2UCHr"};